import { render, staticRenderFns } from "./TargetAndRewardValues.vue?vue&type=template&id=34d68a39&scoped=true&"
import script from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
export * from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndRewardValues.vue?vue&type=style&index=0&id=34d68a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d68a39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d68a39')) {
      api.createRecord('34d68a39', component.options)
    } else {
      api.reload('34d68a39', component.options)
    }
    module.hot.accept("./TargetAndRewardValues.vue?vue&type=template&id=34d68a39&scoped=true&", function () {
      api.rerender('34d68a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Weekly/components/TargetAndRewardValues.vue"
export default component.exports